import React from 'react';
import { MessageSquareIcon } from 'lucide-react';
export function DataDirectoryCustomCta() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-709">
      <div className="bg-blue-50 rounded-[2.5rem] border border-blue-100 p-8 md:p-12 text-center relative overflow-hidden" data-id="element-710">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-711">
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-712"></div>
          <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-713"></div>
        </div>

        <div className="relative z-10 max-w-3xl mx-auto" data-id="element-714">
          <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-blue-600 mx-auto mb-6 shadow-sm border border-blue-100" data-id="element-715">
            <MessageSquareIcon className="w-8 h-8" data-id="element-716" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-717">
            Need custom data or can't find your category?
          </h2>
          <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto" data-id="element-718">
            We can provide tailored local business listings for your specific
            needs or add new business categories to our database.
          </p>
          <a href="https://www.openmart.com/contact" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors shadow-sm" data-id="element-719">
            Contact us for custom solutions
          </a>
        </div>
      </div>
    </section>;
}